module.exports = __webpack_public_path__ + "static/media/adPreviewBackground.53d622d7.png";